<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <g opacity="0.5">
            <path d="M17.8666 9.20833L10.2082 16.8667C9.27005 17.8049 7.99757 18.3319 6.67075 18.3319C5.34393 18.3319 4.07145 17.8049 3.13325 16.8667C2.19505 15.9285 1.66797 14.656 1.66797 13.3292C1.66797 12.0023 2.19505 10.7299 3.13325 9.79167L10.7916 2.13333C11.4171 1.50786 12.2654 1.15648 13.1499 1.15648C14.0345 1.15648 14.8828 1.50786 15.5082 2.13333C16.1337 2.7588 16.4851 3.60712 16.4851 4.49167C16.4851 5.37621 16.1337 6.22453 15.5082 6.85L7.84158 14.5083C7.52885 14.8211 7.10469 14.9968 6.66242 14.9968C6.22014 14.9968 5.79598 14.8211 5.48325 14.5083C5.17051 14.1956 4.99482 13.7714 4.99482 13.3292C4.99482 12.8869 5.17051 12.4627 5.48325 12.15L12.5582 5.08333" stroke="#858E97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconPaperClip',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
